var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name === 'kiosk' || _vm.$route.name === 'add-kiosk' || _vm.$route.name === 'edit-kiosk')?_c('add-kiosk-view',{attrs:{"readonly":_vm.$route.name === 'kiosk'}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dee3174","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kiosks/MainView.vue
// module id = 1422
// module chunks = 62